import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsAndroidApp() {
    const features = [
        {
            title: 'Custom Android App Development',
            description:
                'Our custom android app development services are strategized to offer you a magnitude of Android advantages. We provide customer-focused Android app development solutions per your explicit requirements to streamline your business operations effectively.',
            icon: '/img/technology/ic-custom-app-development.svg',
        },
        {
            title: 'Android Application UI/UX Design',
            description:
                'As an Android Application Development Agency, our experienced UI/UX designers can apply the best UI/UX design techniques. We design Android apps that are more engaging and intuitive in design to give users the best-in-class experience across all devices.',
            icon: '/img/technology/ic-android-application.svg',
        },
        {
            title: 'Android App Porting',
            description:
                'We offer an all-inclusive porting service for your Android mobile app with the latest industry standards and features. Our native android developer can port your mobile application to the Android Platform to magnetize more customers and increase business ROI.',
            icon: '/img/technology/ic-android-porting.svg',
        },
        {
            title: 'Android App Testing',
            description:
                "We are a renowned Android App Development Company with vast experience in making your highly functional app market-ready. Our Android experts perform rigorous testing to check for bugs to avoid any sort of glitch in the app operation.",
            icon: '/img/technology/ic-androidapp-testing.svg',
        },
        {
            title: 'Android Support & Maintenance',
            description:
                'Our end-to-end Android support and maintenance services include app monitoring, optimization, version upgrades, security patches, functional enhancements, and bug and error-free Android applications for your seamless business growth.',
            icon: '/img/technology/ic-support-maintenance.svg',
        },
        {
            title: 'Android App Consultation',
            description:
                'We will be there with you from the start to the end of your Android app development. Our Android developers will comprehend your app idea to convert your vision into a reality. Our team will also analyze your business model and kick-start the Android development process.',
            icon: '/img/technology/ic-android-consultation.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
